import {
  Component,
  Input,
  Output,
  EventEmitter,
  Inject,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements AfterViewInit {
  appConfig: any;
  actionsToRight: any;
  rotateAngle: number = 0;
  @ViewChild('galleryImage') galleryImageEl: ElementRef;
  aspectRatio: number = 0;

  constructor(
    private commInterface: CommunicationInterfaceService,
    public dialogRef: MatDialogRef<GalleryDialogModel>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appdataService: AppdataService
  ) {
    this.appConfig = this.appdataService.getConfig();
    this.actionsToRight = this.appConfig.Miscellaneous?.ButtonArrangement?.actionsToRight;
    this.commInterface.logToServer('info', 'GalleryComponent.constructor', 'Gallery component initialized');
  }

  ngAfterViewInit(): void {
    try {
      this.aspectRatio = this.galleryImageEl.nativeElement.height / this.galleryImageEl.nativeElement.width;
      if (this.aspectRatio > 1)
        this.aspectRatio = this.galleryImageEl.nativeElement.width / this.galleryImageEl.nativeElement.height;
    } catch (error) {
      console.error('%c Error Occured in ngAfterViewInit', 'color: red', error);
      this.commInterface.sendUIErrors('GalleryComponent', 'ngAfterViewInit', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in GalleryComponent.ngAfterViewInit',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to close the gallery dialog
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Method to calculate the scale of the image based on image orientation and rotate angle
   * @returns boolean
   */
  getImageScale(): number {
    try {
      return this.rotateAngle && this.rotateAngle % 360 != 0 && this.rotateAngle % 180 != 0 ? this.aspectRatio : 1.0;
    } catch (error) {
      console.error('%c Error Occured in getImageScale', 'color: red', error);
      this.commInterface.sendUIErrors('GalleryComponent', 'getImageScale', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in GalleryComponent.getImageScale', JSON.stringify(error));
    }
  }
}

/**
 * Class to represent gallery dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class GalleryDialogModel {
  constructor() {}
}
